import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup as MuiRadioGroup, RadioProps, InputAdornment, IconButton } from '@mui/material';
import React from 'react';
import cx from '../../utils/cx';
import styles from './RadioGroup.scss';

export interface IRadioGroupProps {
    label?: string;
    name?: string;
    onChange: (ev) => void;
    value: string;
    defaultValue?: string;
    options: Array<{ label: string; value: string; className?: string}>;
    className?: string;
    required?: boolean;
    row?: boolean;
    inputProps?: RadioProps['inputProps'] | Record<string, string>;
}

const RadioGroup: React.FC<React.PropsWithChildren<IRadioGroupProps>> = ({ label, defaultValue, name, onChange, value, options, required, row, className = '', inputProps  }) => {
    return (
        <FormControl component="fieldset" className={cx(styles.radioGroup, className)}>
            {label && <FormLabel component="legend">{label}</FormLabel>}
            <MuiRadioGroup aria-label={label} row={row} defaultValue={defaultValue} value={value !== null ? value : undefined} name={name} onChange={onChange}>
                {options.map((o) => (
                    <FormControlLabel key={o.label} value={o.value} control={<Radio required={required} inputProps={inputProps} />} label={o.label} className={o.className}/>
                ))}
            </MuiRadioGroup>
        </FormControl>
    );
};

export default RadioGroup;
